import * as autobahn from 'autobahn';
import { Store } from 'redux';
import _get from 'lodash/get';
import Logger from 'js-logger';
import { init, WampConnection } from '@lifesize/clients.connect';
import { ACCOUNT_STATUS, CheckInState, setCheckIn, updateAccountStatus } from 'redux/checkInSlice';
import { setWampConnectError, userLoggedIn } from 'redux/loginSlice';
import * as c from 'utils/constants/constants';
import { lsGet, LsKey, lsSet } from 'utils/localStorageUtils';

let wampCall: WampConnection['call'];
const searchParams = new URLSearchParams(window.location.search);

export const getTokenFromUrl = () => {
  const jwt = searchParams.get('A') || searchParams.get('a');
  if (jwt) lsSet(LsKey.A_TOKEN, jwt);
  return jwt || lsGet(LsKey.A_TOKEN);
};

/**
 * to enable communication with parent window. invoke it only after officeJS.ready() is called.
 */
export const officeDialogActionInterceptor = () => {
  const action = searchParams.get('action');
  const messageParent = _get(Office, 'context.ui.messageParent');
  const jwt = lsGet(LsKey.A_TOKEN);
  switch (action) {
    case c.LOGIN_ACTION:
      Logger.log('Sending LOGIN_SUCCESS message to parent window');
      messageParent && messageParent(JSON.stringify({ action: c.LOGIN_SUCCESS, payload: jwt }));
      break;
    case c.LOGOUT_ACTION:
      Logger.log('Sending LOGOUT_ACTION message to parent window');
      messageParent && messageParent(JSON.stringify({ action: c.LOGOUT_SUCCESS }));
      break;
  }
};
export const initialize = async (token: string, store: Store<object>) => {
  const [WampConnection, Login] = init(autobahn);
  try {
    const loginRes: CheckInState = await Login.login(c.appDomain, token);
    wampCall = WampConnection.call;
    const checkIn = _get(loginRes, 'checkin', {});
    store.dispatch(setCheckIn(checkIn));
    store.dispatch(userLoggedIn());
  } catch (e) {
    Logger.error(JSON.stringify(e));
    if (e.reason === c.WAMP_JWT_ERROR) {
      // Give officeJS some time to get Initialized.
      setTimeout(() => {
        lsSet(LsKey.A_TOKEN, '');
        store.dispatch(setWampConnectError(true));
      }, 250);
    }
    if (e.statusCode === c.HTTP_CODE_401) {
      store.dispatch(updateAccountStatus(ACCOUNT_STATUS.UNAUTHORIZED));
    }
    throw e;
  }
};

export { wampCall };
